import React, { useCallback, useRef, useState } from 'react'
import { SLowcodeList, STableActions, SActionBtn, SDrawer, SGeneralForms } from 'shj-components'
import { Button, Col, DatePicker, Row, Table, Tabs, Drawer } from 'antd'
import { get } from 'lodash-es'
import QuickDateSelector from '@/components/QuickDateSelector'
import DataBoard from './components/dataBoard' // 数据看板
import TaskList from './components/taskList' // 我的待办
import RecentlyVisited from './components/recentlyVisited' // 最近访问
import QuickEntrance from './components/quickEntrance' // 快捷入口
import Weather from './components/weather' // 天气


import styles from './index.module.less'

const homePage = (props: any) => {
  const listRef = useRef<any>()


  return (
    <div className={styles.homePage}>
      <Row gutter={[10, 10]}>
        <Col span={19}>
          <DataBoard />
          <TaskList />
          <RecentlyVisited />
        </Col>
        <Col span={5}>
          <Weather />
          <QuickEntrance />
          <img
            style={{ backgroundColor: '#fff', height: '257px',width:"100%" }}
            src="https://static.shjmall.cn/sass/banner.png"
          />
        </Col>
      </Row>

    </div>
  )
}
export default homePage
